var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('Form',{ref:"createUser",attrs:{"submit":_vm.submit,"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }